import { useCallback, useEffect, useState } from "react";
import { fetchItCheckList, type ItCheck } from "../api/itCheck";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

interface Opts {
  page: number;
  pageSize: number;
  enabled?: boolean;
}

export const useItCheckList = ({ page, pageSize, enabled = true }: Opts) => {
  const [data, setData] = useState<ItCheck[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [token, setToken] = useState(0);

  const refetch = useCallback(() => setToken((t) => t + 1), []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchItCheckList({
      queryString: "",
      page,
      pageSize,
      direction: "desc",
    })
      .then((items) => {
        if (!cancelled) setData(items);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(getApiErrorMessage(err, "Не удалось загрузить проверки минцифры"));
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [page, pageSize, enabled, token]);

  return { data, loading, error, refetch };
};
